<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="filter-search">
    <div class="search-button-icon" @click="searchHandler(userinput)" />
    <input
      id="search-input"
      v-model="userinput"
      type="text"
      :placeholder="$t('search_placeholder')"
      @keyup="searchHandler(userinput)"
    >
    <div v-if="userinput !== ''" class="reset-search" @click="resetSearch()" />
  </div>
</template>

<script>
/**
 * Filter Search input
 * @example [none]
 */
export default {
  name: 'FilterSearch',
  props: {},
  data() {
    return {
      userinput: '',
    }
  },
  computed: {},
  methods: {
    /**
     * Emits an event to know when the user search a new value with Search button click or pressing enter keyboard key
     * @public This is a public method
     * @param {String} value search string value
     */
    searchHandler: function (value) {
      /** Triggers when the user search a value
       * @event search-pressed
       * @property {String} value new value searched
       */
      this.$emit('search-pressed', value)
    },
    /**
     * Sets the input user search value to empty string
     * @public This is a public method
     */
    resetSearch: function () {
      this.userinput = ''
      this.$emit('search-pressed', '')
    },
  },
}
</script>

<style lang="stylus" scoped>
.filter-search
  position: relative
  display: flex
  flex-direction: row
  align-items: center
  width: 100%

  input
    margin: vw(10px) 0
    padding: vw(8px) vw(33px)
    width: 100%
    border: none
    background-color: $bcn-grey
    m-font-size(16, 20)

  .search-button-icon
    position: absolute
    left: vw(3px)
    m-icon("search-black", 26)

  .reset-search
    position: absolute
    top: vw(10px)
    right: vw(0)
    m-icon("close", 30)
</style>
